<div [class.required]="model.required" class="question">
  <ion-item
    [class.answerRequired]="model.highlight && (currentValue == null || currentValue.length == 0)"
    class="ion-no-padding ion-text-wrap"
    lines="none"
  >
    @if (!loading) {
      <ion-select
        #selectRef
        labelPlacement="start"
        label="{{model.questionResolved}}"
        multiple="true"
        [value]="currentValue"
        okText='{{ "BUTTONS.SAVE" | translate }}'
        cancelText='{{ "BUTTONS.CANCEL" | translate }}'
        [disabled]="model.isDisabled"
        (ionChange)="emitAnswer($event.detail.value)"
        class="ion-text-wrap"
      >
        @for (option of model.options; track $index; let i = $index) {
          <ion-select-option [value]="model.values[i]">
            {{ model.optionsResolved[i] }}
          </ion-select-option>
        }
      </ion-select>
    }
  </ion-item>
</div>
